import React from 'react';

export default ({ children, titoloSezione }) => (
    <section className="container in-evidenza">
        {titoloSezione && <h2>{titoloSezione}</h2>}
        <div className="px-custom py-3">
            <div className="row">
                {children}
            </div>
        </div>
    </section>
);



